import { render, staticRenderFns } from "./Terms_of_service.vue?vue&type=template&id=94646728"
import script from "./Terms_of_service.vue?vue&type=script&lang=js"
export * from "./Terms_of_service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports